const showDescriptionTask = (view, item) => {
    view.setHTML(`<h3>Описание:</h3>${item.description}`);
};

export default showDescriptionTask;
